<template>
<div ref="EditPet">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑宠物</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="petlist.length > 1 ? petlist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回宠物管理</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in petlist" :key="index">
            <div class="TTL-form-submit-box-title">宠物-{{index+1}}</div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">宠物相册<i>（点击右下角选择指定图片作为宠物封面图片，如不选择系统默认第一张为封面图片）</i></label>
                    <wcuploadmore :option="{type:'select'}" 
                        :value="item.photos" 
                        @finish="(val)=> {
                            var photos=val.url;
                            item.photos=photos;
                            for(var i=0;i < photos.length; i++) {
                                if(photos[i].is_cover) item.thumb=photos[i].thumb;
                            }

                        }" 
                    />
                </el-form-item>
                <div class="TTL-form-submit-box-title petTitle">基础设置</div>
                <el-form-item>
                    <div class="TTL-form-item-info">
                        <label class="TTL-form-label label-width-auto">宠物名称<i>*</i></label>
                        <div class="TTL-input width250 TTL-form-input left20">
                        <el-input v-model="item.name" placeholder="请输入宠物名称" @change="SaveDataToBrowser" clearable />
                        </div>

                        <label class="TTL-form-label label-width-auto left20">所属类型<i>*</i></label>
                        <div class="TTL-select width150 left20">
                        <el-select v-model="item.pettype" placeholder="请选择宠物类型" @change="[item.breedid='',SaveDataToBrowser]" filterable>
                        <el-option v-for="(item,index) in typelist" :key="index" :label="item.name" :value="item.id" />
                        </el-select>
                        </div>

                        <label class="TTL-form-label label-width-auto left20">品种<i>*</i></label>
                        <div class="TTL-select left20">
                        <el-select v-model="item.breedid" placeholder="请选择宠物品种" @change="SaveDataToBrowser" clearable filterable>
                        <el-option v-for="(t,i) in breedlist" :key="i" :label="t.breedname" :value="t.id" v-show="item.pettype!='' && item.pettype==t.typeid"/>
                        </el-select>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="TTL-form-item-info top10">
                        <label class="TTL-form-label label-width-auto">生日<i>*</i></label>
                        <div class="TTL-datetime width250 left20">
                        <el-date-picker v-model="item.birthday" type="date" value-format="YYYY-MM-DD" placeholder="请选择宠物生日" @change="SaveDataToBrowser" />
                        </div>

                        <label class="TTL-form-label label-width-auto">身高</label>
                        <div class="TTL-input TTL-append TTL-form-input width150 left20">
                        <el-input v-model="item.height" placeholder="请填写宠物身高" @change="SaveDataToBrowser" clearable >
                        <template #append>cm</template>
                        </el-input>
                        </div>

                        <label class="TTL-form-label label-width-auto left20">体重</label>
                        <div class="TTL-input TTL-append TTL-form-input width150 left20">
                        <el-input v-model="item.weight" placeholder="请填写宠物体重" @change="SaveDataToBrowser" clearable >
                        <template #append>kg</template>
                        </el-input>
                        </div>
                    </div>
                </el-form-item>
                <div class="TTL-form-submit-box-title petTitle">高级设置</div>
                <el-form-item>
                    <label class="TTL-form-label">是否绝育<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.issterilization" placeholder="请选择是否绝育" @change="SaveDataToBrowser" filterable>
                    <el-option v-for="(item,index) in issterilization" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">是否种公/母<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.iszhong" placeholder="请选择是否种公/母" @change="SaveDataToBrowser" filterable>
                    <el-option v-for="(item,index) in iszhong" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">被毛类型<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.hairtype" placeholder="请选择被毛类型" @change="SaveDataToBrowser" filterable>
                    <el-option v-for="(item,index) in hairtype" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">血型<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.bloodtype" placeholder="请选择被血型" @change="SaveDataToBrowser" filterable>
                    <el-option v-for="(item,index) in bloodtype" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">销售状态<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.salestatus" placeholder="请选择销售状态" @change="SaveDataToBrowser" filterable>
                    <el-option v-for="(item,index) in salestatus" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">疫苗信息<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.vaccines" placeholder="请选择疫苗情况" @change="SaveDataToBrowser" filterable>
                    <el-option v-for="(item,index) in vaccines" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">是否驱虫<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.DownMing" placeholder="请选择是否驱虫" @change="SaveDataToBrowser" filterable>
                    <el-option v-for="(item,index) in downmonings" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>

                <div class="TTL-form-submit-box-title petTitle">备注设置</div>
                <el-form-item>
                    <label class="TTL-form-label">宠物备注</label>
                    <div class="TTL-input">
                    <el-input type="textarea" v-model="item.petnote" class="width350" :autosize="{ minRows: 6, maxRows: 8}" />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">备注</label>
                    <div class="TTL-input">
                    <el-input type="textarea" v-model="item.note" class="width350" :autosize="{ minRows: 6, maxRows: 8}" />
                    </div>
                </el-form-item>

            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            type:'add',
            file:'',             //图片变量，占位符
            addlimit: 10,        //单次新增限制
            uploadimageIndex:'', //获取当前上传图片的序号
            breedlist:[],        //品种信息
            typelist:[],        //宠物类型
            issterilization:[],  //是否绝育
            iszhong:[],          //是否中公种母
            hairtype:[],         //毛发类型
            bloodtype:[],        //血型
            salestatus:[],       //销售状态
            sexlist:[],          //宠物性别
            vaccines:[],         //疫苗情况
            downmonings:[],      //驱虫信息
            petlist:[
                {id:'',thumb:'',photos:[],name:'',breedid:'',breedname:'',height:'',weight:'',sex:'',birthday:'',
                 pettype:'',issterilization:'',iszhong:'',hairtype:'',bloodtype:'',salestatus:'',vaccines:'',DownMing:'',petnote:'',note:''},
            ],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetBreedInfos();        //获取宠物类型信息
            this.GetPetTypelist();       //获取宠物类型
            this.GetAttribute();         //获取宠物附加属性信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm('当前有数据正在执行编辑操作，是否要执行覆盖操作 ？','操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetPetInfos(data.ids); //获取待处理宠物
                }).catch(()=> {
                    
                });
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.ParseDataFromBrowser(); //解析之前填写的数据
            }else {
                this.GetPetInfos(data.ids); //获取
            }
        },


        /** 提交数据 **/
        submitData() {
            var checkresult=this.CheckDataBeforeSubmit();
            if(checkresult.error==1) {this.$notice({title:'提交数据提示',message:checkresult.message,type:'warning'});return false;}

            //调整提交数据
            var data=[];
            for(var i=0;i<this.petlist.length;i++) data.push(this.petlist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.EditPet;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_PETS.EDIT_PET({petdata:data}).then((res) => {
                this.$loading.closeloading(loadingobj); //关闭等待动画
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.ClearDataFromBrowser(); //清空浏览器里保存的数据
                this.GoBackPets(true); //删除当前组件返回宠物列表组件
            });
        },


        /** 数据提交前进行检测 **/
        CheckDataBeforeSubmit() {
            var result={error:0,message:''};
            if(this.petlist.length==0) {result={error:1,message:'请添加宠物信息'};return result;}

            //检测品种参数
            var name;
            var breedid;
            for(var i=0;i < this.petlist.length;i++) {
                name=this.petlist[i].name;
                breedid=this.petlist[i].breedid;
                if(!name || name=='') {result={error:1,message:'第'+(i+1)+'个宠物名称不能为空'};return result;}
                if(!breedid || breedid=='') {result={error:1,message:'第'+(i+1)+'个宠物品种请选择'};return result;}
            }
            return result;
        },


        /** 获取宠物信息 **/
        GetPetInfos(ids) {
            var loadingobj=this.$refs.EditPet;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_PETS.GET_PET_INFO_LIST({ids:ids,p:1,rollpage:1000000}).then((res) => {
                this.$loading.closeloading(loadingobj); //关闭等待动画
                if(res.status > 0) return false;
                this.petlist=res.data.list;
                for(var i=0;i<this.petlist.length;i++) this.petlist[i].sex=String(this.petlist[i].sex);
            });
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 获取宠物类型信息 **/
        GetBreedInfos() {
            INTERFACE_MODEL_PETS.GET_PET_BREEDS_ALL({}).then((res) => {
                 if(res.status > 0) return false;
                 this.breedlist=res.data;
             });
        },


        /** 获取宠物类型 **/
        GetPetTypelist() {
            INTERFACE_MODEL_PETS.GET_PET_Types({}).then((res) => {
                 if(res.status > 0) return false;
                 this.typelist=res.data;
            });
        },


        /** 获取重复附加属性 **/
        GetAttribute() {
            INTERFACE_MODEL_PETS.GET_PET_ATTRIBUTE({}).then((res) => {
                 if(res.status > 0) return false;
                 var datainfo=res.data;
                 this.sexlist=datainfo.sex; //性别信息
                 this.issterilization=datainfo.issterilization; //是否绝育信息
                 this.iszhong=datainfo.iszhong; //是否种公信息
                 this.hairtype=datainfo.hairtype; //被毛类型
                 this.bloodtype=datainfo.bloodtype; //血型
                 this.salestatus=datainfo.salestatus; //销售状态
                 this.vaccines=datainfo.vaccines; //疫苗情况
                 this.downmonings=datainfo.downmoning; //驱虫信息
            });
        },


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.petlist);
            localStorage.setItem('editpetdata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('editpetdata');
            data ? data : data=[];
            
            !data || data=='' || data==[] ? 
            this.petlist=[{
                id:'',thumb:'',photos:[],name:'',breedid:'',breedname:'',height:'',weight:'',sex:'',birthday:'',
                pettype:'',issterilization:'',iszhong:'',hairtype:'',bloodtype:'',salestatus:'',
                vaccines:'',DownMing:'',petnote:'',note:''
            }] : 
            this.petlist=JSON.parse(data);
        },

        /** 从浏览器中清空当前数据 **/
        ClearDataFromBrowser() {
            this.petlists=[];
            localStorage.setItem('editpetdata','');
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'宠物管理',labelentry:'Pet',components:'Pet',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditPet'; //跳转后要删除的组件
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.TTL-form-item-info {display: inline-flex;align-items: center;}
.label-width-auto {width: auto;}
</style>